import { Close } from '@project-lary/react-material-symbols';
import { useInfoPanelDetails } from 'gcs-common/clients/api/entities/channels/channel-api';
import IconButton from 'gcs-common/design-system/ui/icon-button';
import { useSidebar } from 'gcs-common/design-system/ui/sidebar';
import ProfileImage, { ProfileImageSize } from './ListComponents/ProfileImage';

type InfoPanelHeaderProps = {
  userIds: string[];
  channelId: string;
  isCurrentUserAgent: boolean;
};

const MAX_NUMBER_OF_USERS_TO_SHOW = 4;
const MAX_NUMBER_OF_IMAGES_TO_SHOW = 2;

const InfoPanelHeader = (props: InfoPanelHeaderProps) => {
  const userIdsToDisplay = props.userIds.slice(0, Math.max(MAX_NUMBER_OF_USERS_TO_SHOW, props.userIds.length));
  const { data } = useInfoPanelDetails(props.channelId);

  const usersToDisplay = data?.users.filter((user) => userIdsToDisplay.includes(user.id)) ?? [];
  const userNamesToDisplay = usersToDisplay.map((user) => user.friendlyName);

  const numberOfImagesToDipslay = Math.min(MAX_NUMBER_OF_IMAGES_TO_SHOW, usersToDisplay.length);
  const userImagesToDisplay = usersToDisplay.slice(0, numberOfImagesToDipslay).map((user) => user.imageUrl);

  const userFromCustomer = usersToDisplay.find((user) => user.userType === 'CRAFTSMAN');
  const customerName = userFromCustomer?.customerFriendlyName;
  const customerNo = userFromCustomer?.customerNo;
  const chatTitle = data?.channelType === 'sales_space' ? 'Teamchat' : 'Direkter Chat';
  const isAgentInternalChat = !usersToDisplay.some((user) => user.userType === 'CRAFTSMAN');

  const { toggleSidebar } = useSidebar();
  return (
    <div className="flex flex-col">
      <div className="box-border flex h-[76px] flex-row items-center border-0 border-neutral-7 border-b border-solid p-4">
        <div className="flex-1" />
        <div className="text-center text-base">{chatTitle}</div>
        <div className="flex flex-1 justify-end">
          <button>
            <IconButton
              Icon={Close}
              iconSize="size-6"
              className="cursor-pointer"
              size="m"
              variant="ghost_neutral"
              onClick={toggleSidebar}
            />
          </button>
        </div>
      </div>
      <div className="flex flex-col items-center gap-4 p-4">
        {userImagesToDisplay.length === 1 ? (
          <div className="self-center">
            <ProfileImage
              imageUrl={userImagesToDisplay[0]}
              size={ProfileImageSize.LARGE}
              isRounded={props.isCurrentUserAgent}
            />
          </div>
        ) : (
          <div className=" relative h-24 w-24">
            <div className="absolute top-0 right-0 h-[68px] w-[68px]">
              <ProfileImage imageUrl={userImagesToDisplay[0]} size={ProfileImageSize.MEDIUM} isRounded={true} />
            </div>
            <div className="absolute bottom-0 left-0 h-[68px] w-[68px]">
              <ProfileImage imageUrl={userImagesToDisplay[1]} size={ProfileImageSize.MEDIUM} isRounded={true} />
            </div>
          </div>
        )}
        <div className="justify-items-center">
          <div className="text-xl">{userNamesToDisplay?.join(' & ')}</div>
          {chatTitle === 'Teamchat' && <div className="pb-1 text-xl"> Innendienst </div>}{' '}
          {props.isCurrentUserAgent && !isAgentInternalChat && (
            <div className="text-neutral-11 text-sm"> {`${customerName} ∙ ${customerNo}`} </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InfoPanelHeader;
